import React, { useState, useEffect } from "react";
import "./reports.css";
import { useAuth } from "../../context/API_Client";
import { useNavigate } from "react-router-dom";
import "../analytics/analytics.css";
import ReportsGenerated from "./reportsGenerated";
import LoadingLogoPage from "../loadingPage/loadingPage";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import EmptyState from "../../reusableComponents/ConfigEmptyState/EmptyState";
import { customToast } from "../../reusableComponents/customToaster/customToast";

export default function Reports(operationPermissions) {
  const navigate = useNavigate();
  const { getAllVisualizationData } = useAuth();
  const [allReports, setAllReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  let toDate = new Date();
  toDate.setHours(23, 59, 59, 999);
  let fromDate = new Date(toDate);
  fromDate.setMonth(fromDate.getMonth() - 13);
  fromDate.setHours(0, 0, 0, 0);
  useEffect(() => {
    getAllVisualizationData(
      "merchant_reports",
      {
        fromDate: fromDate,
        toDate: toDate,
        limit: 500,
        sort: {
          addedTimestamp: "desc",
        },
      },
      function (data) {
        setAllReports(data?.points);
        setLoading(false);
      },
      function (errorMsg) {
        customToast("error", "high", errorMsg);
        setLoading(false);
      }
    );
  }, []);

  return (
    <>
      {loading ? (
        <div
          className="content-wrapper"
          style={{
            backgroundColor: "white",
          }}
        >
          <section
            className="content"
            style={{
              backgroundColor: "white",
              marginTop: "24px",
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadingLogoPage />
          </section>
        </div>
      ) : allReports?.length > 0 ? (
        <ReportsGenerated
          reportData={allReports}
          operationPermissions={operationPermissions}
        />
      ) : (
        <div className="content-wrapper" style={{ background: "white" }}>
          <section className="content">
            <div
              style={{
                width: "100%",
                borderRadius: "16px",
                border:
                  "1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12))",
                width: "100%",
              }}
            >
              <EmptyState
                image={
                  <SummarizeOutlinedIcon
                    sx={{
                      color: "rgba(201, 201, 204, 1)",
                      height: "120px",
                      width: "120px",
                    }}
                  />
                }
                mainText={"Reports"}
                subText={
                  "Generate reports for all your business transactions, settlements, payment links & subscription in one place"
                }
                btnText={"Generate Report"}
                btnFunction={() => {
                  navigate("/reports/createReport");
                }}
                btnPermission={operationPermissions?.createReport}
              />
            </div>
          </section>
        </div>
      )}
    </>
  );
}
